import { pageViewTypes } from "@constants/tracking";
import ArticlesRouteContainer from "@features/articles/containers/ArticlesRouteContainer";
import useAnalytics from "@hooks/useAnalytics";

const LibraryRoute = () => {
	useAnalytics({
		type: pageViewTypes.library,
	});
	return <ArticlesRouteContainer />;
};

export default LibraryRoute;
